import { FormField } from 'ui/formField';
import { useSelector } from 'react-redux';
import { getSystemWebhookState } from '../selectors';
import { SystemWebhookFormState } from '../types';
import { WEBHOOK_ERRORS } from '../constants';
import CustomHTTPHeaders from './CustomHTTPHeaders';

export const CustomHttpHeadersFormField = ({
  updateWebhook,
  webhook,
}: {
  webhook: SystemWebhookFormState;
  updateWebhook: (field: string, value: string) => void;
}) => {
  const systemWebhookState = useSelector(getSystemWebhookState);
  const errors = (systemWebhookState as Record<string, any>)?.errors;
  const hasInvalidHTTPHeader = errors.includes(WEBHOOK_ERRORS.EMPTY_HEADER_FIELD);

  return (
    <FormField
      inputId="httpHeaders"
      labelText="Custom HTTP headers"
      errorText="HTTP headers must have a non-empty field name"
      hasError={hasInvalidHTTPHeader}
    >
      <CustomHTTPHeaders
        existingHeaders={webhook.headers}
        // @ts-ignore
        onHeadersChange={(value) => updateWebhook('headers', value)}
      />
    </FormField>
  );
};
